import { Navigate } from "react-router-dom";
import { useAuth } from "kmstack-shared/providers";

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { loading, isAuthenticated } = useAuth();

  if (loading) return null; // Or loading screen

  if (!isAuthenticated) {
    localStorage.setItem("postLoginRedirect", window.location.pathname);
    return <Navigate to="/login" replace />;
  }

  return children;
};
